import { Text, TextProps } from '@chakra-ui/react';
import React from 'react';

export type TitleProps = TextProps & {
  title?: string;
  children?: React.ReactNode;
};

export const Title: React.FC<TitleProps> = ({ title, children, ...props }) => {
  return (
    <Text fontSize={'sm'} {...props}>
      {title}
      {children}
    </Text>
  );
};
